import { useTranslation } from "react-i18next";
import { ApiError } from "../api/problem";
import { Button } from "./Button";

/**
 * A contract error is shown with its message (WEB-F-SH-05); anything else with a generic title, and with its technical
 * message only when `technical` is set (a page that crashed), so a report can quote it.
 */
export function ErrorMessage({
  error,
  onRetry,
  technical = false,
}: {
  error: unknown;
  onRetry?: () => void;
  technical?: boolean;
}) {
  const { t } = useTranslation();
  const detail = error instanceof ApiError ? error.message : undefined;
  const tech = technical && !(error instanceof ApiError) && error instanceof Error ? error.message : undefined;
  return (
    <div role="alert" className="m-6 rounded-md border border-red-300 bg-red-50 p-4 text-sm text-red-900">
      <p className="font-medium">
        {error instanceof ApiError ? t("error.status", { status: error.status }) : t("error.title")}
      </p>
      {detail && <p className="mt-1">{detail}</p>}
      {tech && <p className="mt-1 font-mono text-xs break-all">{tech}</p>}
      {onRetry && (
        <Button variant="secondary" className="mt-3" onClick={onRetry}>
          {t("error.retry")}
        </Button>
      )}
    </div>
  );
}
